import React, { useState } from "react";
import { patchApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { Input } from "antd";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";

const CustomerUpdateSection = ({
  onOpen,
  onClose,
  setSectionUpdated,
  sectionId,
  popupData,
  setPopupData,
  clientId,
  sectionName,
}) => {
  const [section, setsection] = useState(sectionName);
  const [error, setError] = useState(false);
  const handleClear = () => {
    setsection("");
    setError(false);
    onClose();
  };

  const handlePopupClose = () => {
    setPopupData(null);
  };

  const createSection = async (section, clientId, sectionId) => {
    try {
      const body = {
        client_id: clientId,
        // status: "Active",
        name: section,
        description: "This is description",
      };
      const response = await patchApi({
        apiUrl: API_URLS.UPDATE_CUSTOMER_SECTION(sectionId),
        headers: { client: clientId },
        data: body,
      });
      if (response.success) {
        setPopupData({
          type: "success",
          title: "Section Edited",
          message: "The new section was successfully Edited.",
        });
        onClose();
      } else {
        setPopupData({
          type: "warning",
          title: "Failed in Editing Section",
          message: `${response.message}`,
        });
        onClose();
      }
    } catch (error) {
      setPopupData({
        type: "error",
        title: "Creation Failed",
        message: "There was a problem updating the section.",
      });
      onClose();
      console.log("Error in creating new Section", error);
    } finally {
      setTimeout(() => {
        setPopupData(null);
      }, 2000);
    }
  };

  const handleSave = async () => {
    if (!section.trim()) {
      setError(true);
      return;
    }
    await createSection(section, clientId, sectionId);
  };

  return (
    <div className="flex justify-center my-4">
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div>
          <h3 className="text-2xl">Edit Section</h3>
          <div
            style={{
              border: "1px solid #ebedf3",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <div className="mb-4">
              <Input
                value={section}
                onChange={(e) => setsection(e.target.value)}
                placeholder="Enter Section Name"
                style={{
                  border: "1px solid #ebedf3",
                  borderRadius: "10px",
                  padding: "10px",
                }}
                className="text-base font-light"
              />
              {error && (
                <p className="text-red-500 text-sm mt-2">
                  Please fill out this field.
                </p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="primary"
              variant="cancel"
              buttonText="Cancel"
              className="text-sm px-6 py-2 rounded-lg"
              onClick={handleClear}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Save"
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={handleSave}
            />
          </div>
        </div>
      </DailogBox>
    </div>
  );
};

export default CustomerUpdateSection;
